/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAttributionModelFromJSON, ApiAttributionModelToJSON, } from './ApiAttributionModel';
import { ApiChartPayloadFromJSON, ApiChartPayloadToJSON, } from './ApiChartPayload';
export function ApiPrimaryRequestPayloadFromJSON(json) {
    return ApiPrimaryRequestPayloadFromJSONTyped(json, false);
}
export function ApiPrimaryRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'attributionModel': !exists(json, 'attributionModel') ? undefined : ApiAttributionModelFromJSON(json['attributionModel']),
        'chart': !exists(json, 'chart') ? undefined : ApiChartPayloadFromJSON(json['chart']),
        'comparisonFrom': !exists(json, 'comparisonFrom') ? undefined : (new Date(json['comparisonFrom'])),
        'comparisonTo': !exists(json, 'comparisonTo') ? undefined : (new Date(json['comparisonTo'])),
        'from': !exists(json, 'from') ? undefined : (new Date(json['from'])),
        'lastNDays': !exists(json, 'lastNDays') ? undefined : json['lastNDays'],
        'leadId': !exists(json, 'leadId') ? undefined : json['leadId'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'to': !exists(json, 'to') ? undefined : (new Date(json['to'])),
    };
}
export function ApiPrimaryRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'attributionModel': ApiAttributionModelToJSON(value.attributionModel),
        'chart': ApiChartPayloadToJSON(value.chart),
        'comparisonFrom': value.comparisonFrom === undefined ? undefined : (value.comparisonFrom.toISOString()),
        'comparisonTo': value.comparisonTo === undefined ? undefined : (value.comparisonTo.toISOString()),
        'from': value.from === undefined ? undefined : (value.from.toISOString()),
        'lastNDays': value.lastNDays,
        'leadId': value.leadId,
        'offset': value.offset,
        'to': value.to === undefined ? undefined : (value.to.toISOString()),
    };
}
